import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContractService } from '../../contract.service';
import { FeiColumn } from '../../../../../../core/base/interfaces/fei-column.interface';
import { AuthService } from '../../../../../../core/services/auth.service';
import { take, tap } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ProductModel } from '../../../../../../core/models/product.model';
import { ProductContractCreateUpdateDeleteComponent } from '../../../product/product-contract-create-update-delete/product-contract-create-update-delete.component';
import { PrestationContractCreateUpdateDeleteComponent } from '../../../prestation/prestation-contract-create-update-delete/prestation-contract-create-update-delete.component';
import { PrestationModel } from '../../../../../../core/models/prestation.model';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ContractBaseComponent } from '../contract-base/contract-base.component';
import { ContractBasketCreateUpdateDeleteComponent } from '../../modals/contract-basket-create-update-delete/contract-basket-create-update-delete.component';
import { ContractModel, ContractPerimeterModel } from '../../../../../../core/models/contract.model';
import { PrestationService } from '../../../prestation/prestation.service';
import { EngagementSelectModalComponent } from '../../modals/engagement-select/engagement-select-modal.component';
import { ProductSelectModalComponent } from '../../modals/product-select/product-select-modal.component';
import { ProductService } from '../../../product/product.service';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';
import icDone from '@iconify/icons-ic/twotone-done';
import icClose from '@iconify/icons-ic/twotone-close';
import { ContractStatusEnum } from '../../../../../../core/enums/contract-status.enum';
import { InterventionTypeEnum } from '../../../../../../core/enums/intervention.enum';
import { TvaService } from '../../../../settings/tva/tva.service';
import { TvaModel } from '../../../../../../core/models/tva.model';
import { Subscription } from 'rxjs';
import { FileSaverService } from 'ngx-filesaver';
import { ProductBulkUpdateModalComponent } from '../../modals/product-bulk-update-modal/product-bulk-update-modal.component';
import { b64ToBlob } from '../../../../../../core/helpers/b64ToBlob.helper';
import { ContentTypeEnum } from '../../../../../../core/base/enum/content-type.enum';
import { ProductEditMultipleComponent } from '../../modals/product-edit-multiple/product-edit-multiple.component';
import { DependenciesService } from '../../../../../../core/services/dependencies.service';

@Component({
  selector: 'vex-contract-details-catalog-intern',
  templateUrl: './contract-details-catalog-intern.component.html',
  styleUrls: ['./contract-details-catalog-intern.component.scss'],
})
export class ContractDetailsCatalogInternComponent extends ContractBaseComponent implements OnInit, OnDestroy {
  feisColumnsArticle: Array<FeiColumn> = [
    { label: 'Référence', column: 'reference', type: 'custom', width: '110px' },
    { label: 'Libellé', column: 'label', wrap: true, width: '30%', minWidth: '250px' },
    { label: 'Fournisseur', column: 'supplier', propertyDisplay: 'supplier.label', width: '150px' },
    {
      label: "Catégorie d'article",
      column: 'genericCategory',
      propertyDisplay: 'genericCategory.label',
      width: '170px',
    },
    { label: 'Périmètre complet', column: 'isFullPerimeter', type: 'custom', width: '150px' },
    // {label: 'Article', column: 'genericProduct', propertyDisplay: 'genericProduct.label'},
    // {label: 'Quantité Minimum', column: 'minQuantity'},
    { label: 'Article générique', column: 'genericProduct', propertyDisplay: 'genericProduct.label', width: '180px' },
    { label: 'UA', column: 'purchaseUnit', width: '80px' },
    { label: 'Conditionnement', column: 'conditioningUnit', width: '150px' },
    {
      label: 'Coût article contrat HT (Prix HT)',
      column: 'priceHT',
      type: 'number',
      additionalDisplay: '€',
      width: '250px',
    },
    {
      label: 'Taux TVA',
      column: 'tva',
      type: 'custom',
      width: '100px',
    },
    {
      label: 'Coût article contrat TTC (Prix TTC)',
      column: 'priceTTC',
      type: 'number',
      additionalDisplay: '€',
      width: '255px',
    },
    {
      label: 'Condition de révision (en %)',
      type: 'number',
      column: 'revisionAmount',
      additionalDisplay: ' %',
      maxDecimal: 2,
      width: '230px',
    },
    { label: 'Visibilité e-Shop', column: 'isSuspended', type: 'eshopStatus', width: '150px' },
    { label: 'Action', column: 'actions', canUpdate: true, canArchive: false, canDelete: true, canSuspend: true },
  ];

  feisColumnsPrestation: Array<FeiColumn> = [
    { label: 'Référence', column: 'reference', type: 'custom', width: '110px' },
    { label: 'Libellé', column: 'label', wrap: true, width: '30%', minWidth: '250px' },
    { label: 'Périmètre', column: 'isFullPerimeter', type: 'custom', width: '100px' },
    // {label: 'Prestation', column: 'genericPrestation', propertyDisplay: 'genericPrestation.label'},
    { label: 'Quantité Minimum', column: 'minQuantity', width: '150px' },
    {
      label: 'Coût prestation contrat HT (Prix HT)',
      column: 'priceHT',
      type: 'number',
      additionalDisplay: '€',
      width: '260px',
    },
    {
      label: 'Taux TVA',
      column: 'tva',
      type: 'custom',
      width: '100px',
    },
    {
      label: 'Coût prestation contrat TTC (Prix TTC)',
      column: 'priceTTC',
      type: 'number',
      additionalDisplay: '€',
      width: '265px',
    },
    {
      label: 'Condition de révision (en %)',
      type: 'number',
      column: 'revisionAmount',
      additionalDisplay: ' %',
      maxDecimal: 2,
      width: '230px',
    },
    { label: 'Nombre Prestations au forfait', column: 'purchasePackageValue', type: 'text', width: '235px' },
    { label: 'Nombre d’interventions initial', column: 'purchaseValueToDisplay', type: 'text', width: '240px' },
    { label: 'Solde de prestations', column: 'purchaseValueRemaining', type: 'text', width: '175px' },
    { label: 'Visibilité e-Shop', column: 'isSuspended', type: 'eshopStatus', width: '150px' },
    { label: 'Intervention planifiée', column: 'interventionRequired', type: 'custom', width: '190px' },
    { label: 'Action', column: 'actions', canUpdate: true, canArchive: false, canDelete: true, canSuspend: true },
  ];

  feisColumns: Array<FeiColumn>;
  tooltip = false;
  showPreviousReference = false;
  ContractStatusEnum = ContractStatusEnum;
  icClose = icClose;
  icDone = icDone;
  prestations;
  previousId;
  perimeter: ContractPerimeterModel[] = [];
  contract: ContractModel;
  isFullPerimter: boolean;
  stockedData: any[] = [];
  isPredikUser = false;
  genericProduct = null;
  genericPrestation = null;
  protected readonly InterventionTypeEnum = InterventionTypeEnum;
  hideTooltipTimeout: any;
  selectedContracts: ContractModel[] = [];
  isContractArchived = false;

  // Step enablement helpers
  get isPerimeterSelected(): boolean {
    return this.selectedContracts && this.selectedContracts.length > 0;
  }

  get hasProducts(): boolean {
    return (this.countProduct || 0) > 0;
  }

  get hasPrestations(): boolean {
    return (this.countPrestation || 0) > 0;
  }

  constructor(
    public contractService: ContractService,
    public prestationService: PrestationService,
    public authService: AuthService,
    private dialog: MatDialog,
    public productService: ProductService,
    public snackbarService: SnackbarService,
    private dependencyService: DependenciesService<ProductModel>,
    private tvaService: TvaService,
    private fileSaver: FileSaverService,
  ) {
    super(contractService, productService, prestationService, authService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initData();
  }

  initData() {
    super.initData();

    this.contractService.entity$.subscribe((contract: ContractModel) => {
      this.isContractArchived = contract?.isArchive === true;

      if (this.isContractArchived) {
        this.feisColumnsArticle = this.removeActionsColumn(this.feisColumnsArticle);
        this.feisColumnsPrestation = this.removeActionsColumn(this.feisColumnsPrestation);
      } else {
        this.isEditableCatalog =
          this.contractService.checkIsEditableCatalog(this.contract) || this.authService.isReferentEngagement();
        if (this.contract.status === ContractStatusEnum.DRAFT || !contract.supportEstablishment) {
          this.feisColumnsArticle = this.updateActionsColumnDraft(this.feisColumnsArticle);
          this.feisColumnsPrestation = this.updateActionsColumnDraft(this.feisColumnsPrestation);
        }
        if (!this.isEditableCatalog) {
          this.feisColumnsArticle = this.updateActionsColumn(this.feisColumnsArticle);
          this.feisColumnsPrestation = this.updateActionsColumn(this.feisColumnsPrestation);
        }

        // Apply canSuspend rule based on user permissions
        this.updateCanSuspendRule();
      }

      // PRED-3230 : les actions de ligne suivent les droits Engagement (modifier / supprimer).
      this.feisColumnsArticle = this.applyContractPermissionsToActions(this.feisColumnsArticle);
      this.feisColumnsPrestation = this.applyContractPermissionsToActions(this.feisColumnsPrestation);

      // If you have any other logics to add for the catalog about a internal contract, thanks to add it in this function :
      this.internalContractLogic(contract);
    });
    this.isPredikUser = this.authService.checkCurrentIsPredik();

    const subCheckPermissions = this.checkPermissions().subscribe();
    this.subscription.add(subCheckPermissions);
  }

  override initDataSources() {
    super.initDataSources({ isArchive: false });
  }

  updateActionsColumn(columns: Array<FeiColumn>) {
    return columns.map(column => {
      if (column.column === 'actions') {
        column.canDelete = this.contract?.status === ContractStatusEnum.DRAFT;
      }
      return column;
    });
  }

  onStockData(data) {
    this.stockedData = data;
  }

  getTvaRate(tva: TvaModel) {
    const rateList = this.tvaService.getRateByDate(tva)?.rate.toFixed(2);
    return `${rateList ? rateList + '%' : '-'}`;
  }

  onFilterEvent(filtersData: any) {
    const search = filtersData.search ? filtersData.search : '';
    const isAvailable = filtersData.filters?.isAvailable ? filtersData.filters?.isAvailable : null;
    const stockable = filtersData.filters?.stockable ? filtersData.filters?.stockable : null;

    const filters = {
      contractId: this.contract._id,
      isAllEstablishment: true,
      requiredFields: ['*'],
      isAvailable,
      stockable,
    };

    let itemsProduct;
    let itemsPrestation;

    if (this.hasArticle && this.entityType === 'products') {
      itemsProduct = this.productService
        .findAll(this.pageIndex, this.pageSize, 'label', 'asc', search, {
          ...filters,
          genericProduct: filtersData.genericProduct,
        })
        .subscribe(res => {
          this.countProduct = res.totalData;
          this.products = res.data;
          this.dataSourceArticle = new MatTableDataSource<ProductModel>(res.data);
          this.loading = false;
        });

      this.subscription.add(itemsProduct);
    }

    if (!this.hasArticle && this.entityType === 'prestations') {
      itemsPrestation = this.prestationService
        .findAll(this.pageIndex, this.pageSize, 'label', 'asc', search, filters)
        .subscribe(res => {
          this.countPrestation = res.totalData;
          this.prestations = res.data;
          this.dataSourcePrestation = new MatTableDataSource<PrestationModel>(res.data);
          this.loading = false;
        });

      this.subscription.add(itemsPrestation);
    }

    this.prestationEmpty = itemsPrestation === 0;
    this.articleEmpty = itemsProduct === 0;

    if (this.prestationEmpty && !this.articleEmpty) {
      this.tabChanges(0);
    } else if (this.articleEmpty && !this.prestationEmpty) {
      this.tabChanges(1);
    }

    if (filtersData.search === '') {
      this.prestationEmpty = false;
      this.articleEmpty = false;
    }
  }

  checkPermissions() {
    return this.authService.getCurrentUserPermissions$().pipe(
      tap((permissions: any) => {
        // this.canUpdateAndAddPermission = permissions.includes(ENUM_PERMISSIONS.INPUT_FM_REF_PURCHASE_COMMITMENT_CATALOG);
        // this.canUpdateQuantityPermission = permissions.includes(ENUM_PERMISSIONS.UPDATE_FM_REF_PURCHASE_COMMITMENT_CATALOG);
        // this.canDeletePermission = permissions.includes(ENUM_PERMISSIONS.DELETE_FM_REF_PURCHASE_COMMITMENT_CATALOG);
        // this.canAddPanierContratPermission = permissions.includes(ENUM_PERMISSIONS.ADD_FM_REF_PURCHASE_COMMITMENT_CATALOG);
      }),
    );
  }

  createPrestIntervention(row) {
    const dialogRef = this.dialog.open(ContractBasketCreateUpdateDeleteComponent, {
      data: {
        mode: CrudModeEnum.Create,
        contract: this.contract,
        prestInterventionId: row._id,
        prestInterventionRequired: row.interventionRequired,
        prestLabel: row.label,
        contractGenericEngagementDataPatrimony: this.contract.genericEngagement.dataPatrimony,
      }, // Passer les données ici
    });
    dialogRef.afterClosed().subscribe({});
  }

  openProductSelect(): void {
    const contractIds = this.selectedContracts.map(c => c._id);

    const dialogRef = this.dialog.open(ProductSelectModalComponent, {
      data: {
        contracts: contractIds,
        alreadySelected: this.products,
        supportEstablishment: this.contract?.supportEstablishment,
        contractId: this.contract?._id,
      },
      width: '60vw',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result?.needsRefresh) {
          this.initDataSources();
        }
      },
    });
  }

  addItem() {
    if (this.entityType === 'products') {
      this.openProductSelect();
    } else {
      this.createContractItem();
    }
  }

  triggerImportBulkUpdate() {
    this.dialog
      .open(ProductBulkUpdateModalComponent, {
        width: '520px',
        disableClose: true,
        data: { contractId: this.contract?._id },
      })
      .afterClosed()
      .subscribe((result?: { success?: boolean }) => {
        if (result?.success) {
          this.initDataSources();
        }
      });
  }

  createContractItem() {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    const sub = this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          mode: CrudModeEnum.Create,
          contract: this.contract,
          messageResult:
            this.entityType === 'products'
              ? "L'article a été ajouté avec succès"
              : 'La prestation a été ajoutée avec succès',
        },
      })
      .afterClosed()
      .subscribe((elements: ProductModel[] | PrestationModel[]) => {
        if (elements) {
          this.initDataSources();
          this.contractService.setIsValid(true);
        }
      });
    this.subscription.add(sub);
  }

  importContractItems(isQuoteUpdate: boolean = false) {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    const sub = this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          mode: CrudModeEnum.Import,
          contract: this.contract,
          isQuoteUpdate: isQuoteUpdate,
        },
      })
      .afterClosed()
      .subscribe((elements: ProductModel[] | PrestationModel[]) => {
        if (elements) {
          this.initDataSources();
          this.contractService.setIsValid(true);
          const resultMessage: string =
            this.entityType === 'products'
              ? 'Les articles ont été importés avec succès'
              : 'Les prestations ont été importé(e)s avec succès';
          this.snackbarService.success(resultMessage);
        }
      });
    this.subscription.add(sub);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subscription.unsubscribe();
  }

  updateItem(element: ProductModel | PrestationModel): void {
    if (this.entityType === 'products') {
      // Use the limited-field editor in single-step mode
      this.dialog
        .open(ProductEditMultipleComponent, {
          data: {
            products: [element as ProductModel],
            forceStepMode: true,
          },
        })
        .afterClosed()
        .subscribe(() => {
          this.initDataSources();
        });
      return;
    }

    // Prestations keep their dedicated editor
    const component = PrestationContractCreateUpdateDeleteComponent;
    // @ts-ignore
    this.dialog
      .open(component, {
        data: {
          defaults: element,
          mode: CrudModeEnum.Update,
          contract: this.contract,
          messageResultUpdate: 'La prestation a été modifiée avec succès',
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.initDataSources();
        }
      });
  }

  async archiveItem(element: ProductModel | PrestationModel) {
    if (this.entityType === 'products') {
      if (element.isArchive) {
        this.productService.unarchive(element as ProductModel).subscribe({
          next: () => {
            this.snackbarService.success('Le produit a été désarchivé avec succès');
            this.initDataSources();
          },
          error: () => {
            this.snackbarService.warning('Une erreur est survenue lors de la désarchivage du produit');
          },
        });
      } else {
        await this.dependencyService
          .setService(this.productService)
          .setModuleName('produit')
          .setModuleNameWithArticle('un produit')
          .setModuleNameTitleWithArticle('du produit')
          .checkDependencies(element as ProductModel, this.initDataSources.bind(this));
      }
    } else {
      this.openArchiveDialog(element);
    }
  }

  private openArchiveDialog(element: ProductModel | PrestationModel) {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          defaults: element,
          name: `${element.label}`,
          mode: CrudModeEnum.Archive,
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.initDataSources();
        }
      });
  }

  deleteItem(element: ProductModel | PrestationModel) {
    // Récupérer l'élément à jour depuis le dataSource pour avoir les dernières modifications
    let currentElement = element;
    if (this.entityType === 'products') {
      const found = this.dataSourceArticle.data.find(p => p._id === element._id);
      if (found) {
        currentElement = found;
      }
    } else {
      const found = this.dataSourcePrestation.data.find(p => p._id === element._id);
      if (found) {
        currentElement = found;
      }
    }

    let defaultMessage = `Êtes-vous sûr de vouloir supprimer ${currentElement.label} ?`;

    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    // Check if the reference exist in recurringBasket
    const subscription: Subscription = this.contractService.reccuringBaskets$
      .pipe(take(1))
      .subscribe(recurringBaskets => {
        const exists = recurringBaskets.some(recurringBasket => {
          const items = recurringBasket[this.entityType];
          return items?.some(item => (item.item as ProductModel | PrestationModel)._id === currentElement._id);
        });

        if (exists) {
          defaultMessage = `Cette référence se trouve dans l'un de vos paniers contrat. Êtes-vous sûr de vouloir supprimer ?`;
        }

        this.dialog
          // @ts-ignore
          .open(component, {
            data: {
              defaults: currentElement,
              name: `${currentElement.label}`,
              mode: CrudModeEnum.Delete,
              defaultMessage,
            },
          })
          .afterClosed()
          .subscribe(
            result => {
              if (result) {
                this.initDataSources();

                this.snackbarService.success(
                  this.entityType === 'products'
                    ? 'Le produit a bien été supprimé'
                    : 'La prestation a bien été supprimée',
                );
              }
            },
            error => {
              this.snackbarService.warning('Une erreur est survenue');
            },
          );

        subscription.unsubscribe();
      });
  }

  isToPlan(element): boolean {
    if (element.genericPrestation?.interventionRequired && !(element.interventionType === InterventionTypeEnum.FIXE)) {
      return true;
    } else {
      return false;
    }
  }

  showTooltipText(element): boolean {
    if (element.interventionType === InterventionTypeEnum.FIXE && element.isPackageService) {
      return true;
    } else {
      return false;
    }
  }

  getTooltipText(element: any): string {
    return `Compteur d'intervention : ${element.purchaseValueRemaining}\n`;
  }

  updateActionsColumnDraft(columns: Array<FeiColumn>) {
    return columns.map(column => {
      if (column.column === 'actions') {
        column.canDelete = true;
      }
      return column;
    });
  }

  showTooltip(state: boolean, element?) {
    if (!state) {
      this.tooltip = false;
      this.previousId = '';
    } else if (element?._id && this.previousId !== element?._id) {
      this.tooltip = true;
      this.perimeter = element.perimeter;
      this.isFullPerimter = element.isFullPerimeter;
      this.previousId = element?._id;
    }
  }

  onMouseEnter(row) {
    this.clearHideTooltipTimeout();
    this.showTooltip(true, row);
  }

  onMouseLeave() {
    this.setHideTooltipTimeout();
  }

  onMouseEnterTooltip() {
    this.clearHideTooltipTimeout();
  }

  onMouseLeaveTooltip() {
    this.setHideTooltipTimeout();
  }

  setHideTooltipTimeout() {
    this.hideTooltipTimeout = setTimeout(() => {
      this.showTooltip(false);
    }, 300);
  }

  clearHideTooltipTimeout() {
    if (this.hideTooltipTimeout) {
      clearTimeout(this.hideTooltipTimeout);
      this.hideTooltipTimeout = null;
    }
  }

  internalContractLogic(contract: ContractModel) {
    if (contract?.supportEstablishment) {
      this.feisColumnsArticle = this.removePerimeterColumn(this.feisColumnsArticle);
      this.feisColumnsPrestation = this.removePerimeterColumn(this.feisColumnsPrestation);
    }
  }

  removePerimeterColumn(columns: FeiColumn[]): FeiColumn[] {
    return columns.filter(col => col.column !== 'isFullPerimeter');
  }

  importModificationContractItems() {
    const component =
      this.entityType === 'products'
        ? ProductContractCreateUpdateDeleteComponent
        : PrestationContractCreateUpdateDeleteComponent;

    const sub = this.dialog
      // @ts-ignore
      .open(component, {
        data: {
          mode: CrudModeEnum.Import,
          contract: this.contract,
          modificationImportItem: true,
        },
      })
      .afterClosed()
      .subscribe((elements: ProductModel[] | PrestationModel[]) => {
        if (elements) {
          this.initDataSources();
          this.contractService.setIsValid(true);
          const resultMessage: string =
            this.entityType === 'products'
              ? 'Les articles ont été modifié avec succès'
              : 'Les prestations ont été modifiées avec succès';
          this.snackbarService.success(resultMessage);
        }
      });
    this.subscription.add(sub);
  }

  openEngagementSelect() {
    this.dialog
      .open(EngagementSelectModalComponent, {
        maxHeight: '95vh',
        minWidth: '80vw',
        data: {
          supportEstablishment: this.contract?.supportEstablishment,
          engagement: this.contract,
          mode: CrudModeEnum.Read,
          selectedEngagements: this.selectedContracts,
        },
      })
      .afterClosed()
      .subscribe((contracts: ContractModel[]) => {
        if (contracts) {
          this.selectedContracts = contracts;
        }
      });
  }

  removeSelectedContract(contract: ContractModel) {
    this.selectedContracts = this.selectedContracts.filter(c => c._id !== contract._id);
  }

  removeActionsColumn(columns: Array<FeiColumn>): Array<FeiColumn> {
    return columns.filter(column => column.column !== 'actions');
  }
}
